import { render, staticRenderFns } from "./nodealinfo.vue?vue&type=template&id=492fa147&scoped=true&"
import script from "./nodealinfo.vue?vue&type=script&lang=js&"
export * from "./nodealinfo.vue?vue&type=script&lang=js&"
import style0 from "./nodealinfo.vue?vue&type=style&index=0&id=492fa147&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492fa147",
  null
  
)

export default component.exports